<template>
    <Modal
        ref="Modal"
        :title="translate('labels.delete_categories')"
    >
        <div class="modal-body">
            {{ translate('alerts.delete_categories_confirm', { number: totalProductsCount }) }}
        </div>
        <div class="table-responsive table-scrollable" v-if="totalProductsCount > 0">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>{{ translate('labels.category') }}</th>
                        <th>{{ translate('labels.product_count') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(count, category) in productsCountByCategory" :key="category">
                        <td>{{ category }}</td>
                        <td>{{ count }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-footer pt-4">
            <Button size="sm" color="light" @click="$refs.Modal.hide()">
                {{ translate('buttons.no') }}
            </Button>
            <Button size="sm" color="danger" @click="remove">
                {{ translate('buttons.yes') }}
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from '../../../../../components/new/modal/AppModal.vue';
import Button from '../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../services/HttpClient';
import { chunk } from '../../../../../utils'

export default {
    name: 'DeleteCategoriesModal',
    components: {
        Modal, Button
    },
    emits: ['category:deleted'],
    data() {
        return {
            productsCountByCategory: {},
            totalProductsCount: 0,
            categoryUuids: []
        }
    },
    methods: {
        async show(categoryUuids) {
            this.categoryUuids = categoryUuids;
            this.productsCountByCategory = {};
            this.totalProductsCount = 0;

            for (const categoryUuid of categoryUuids) {
                const response = await httpClient.get('/catalog/product-items', {
                    category_uuid: categoryUuid,
                    limit: 1,
                    extra: 1
                });

                if (response.data.meta.total === 0) {
                    continue;
                }
                this.productsCountByCategory[response.data.data[0].category.name] = response.data.meta.total;
                this.totalProductsCount += response.data.meta.total;
            }

            this.$refs.Modal.show();
        },
        async remove() {
            let responseData = [];

            for (const categoryUuid of this.categoryUuids) {
                responseData.push({
                    method: 'DELETE',
                    path: `/projects/${this.$route.params.projectUuid}/pim/types/${categoryUuid}`
                })
            }

            await Promise.all(
                chunk(responseData, 10).map(async (chunk) => {
                    await httpClient.post('/batch', {
                        data: chunk
                    });
                })
            );

            this.$emit('category:deleted');
            this.$refs.Modal.hide();
        }
    }
}
</script>